import React from "react";
import "./Projects.css";
import { FaReact, FaHardHat } from "react-icons/fa";
import {
  SiBlockchaindotcom,
  SiHtml5,
  SiMaterialui,
  SiChai,
  SiEthereum,
  SiExpress,
  SiSocketdotio,
  SiTailwindcss,
  SiReactrouter,
  SiJavascript,
  SiMongodb,
  SiNodedotjs
} from "react-icons/si";
import { DiCss3 } from "react-icons/di";
import { VscJson } from "react-icons/vsc";
import { IoLogoJavascript } from "react-icons/io";
export const Projects = () => {
  return (
    <>
      <div id="projects" className="section">
        <h2 className="section__title different" data-aos="fade-right">
          Projects
        </h2>

        
        {/* ZOOMCAR */}

        <div className="project-card">
          <div className="project">
            <div className="project_videocontainer">
              <div data-aos="fade-right">
                <img
                  src="https://user-images.githubusercontent.com/101381281/233326315-0c949bd9-8b23-480f-a828-91c9c160a37f.png"
                  alt="ZoomCar"
                />
              </div>
            </div>
            <div className="project_information" data-aos="fade-right">
              <h2 className="project-title">ZoomCar Clone</h2>
              <p className="project-description">
              Zoomcar is a self-drive car rental platform that offers a wide range of car options at affordable rates, allowing users to rent the car of their choice for their travel needs.
              </p>
              <div className="project-tech-stack">
                <FaReact />
                <SiHtml5 />
                <IoLogoJavascript />
                <SiNodedotjs />
              </div>
              <div >
                <a
                  className="project-deployed-link"
                  href="https://vivek-zoomcar.netlify.app/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline onbt">
                    See this Live
                  </span>
                </a>
                <a
                  className="project-github-link"
                  href="https://github.com/vivekbtu/bitter-level-627"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline">
                    View Code
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Mail-Chimp */}

        <div className="project-card">
          <div className="project">
            <div className="project_videocontainer">
              <div data-aos="fade-right">
                <img
                  src="https://user-images.githubusercontent.com/101381281/204876988-7f3ce8d3-ac0a-469a-ac4b-c30838f461aa.png"
                  alt="Mail Chimp"
                />
              </div>
            </div>
            <div className="project_information" data-aos="fade-right">
              <h2 className="project-title">Mail Chimp</h2>
              <p className="project-description">
                Clone of the popular email campaigning app Mail Chimp. Built on react for front end and nodeJS on backend. It's a team project completed executed in 5 days.
              </p>
              <div className="project-tech-stack">
                <FaReact />
                <SiHtml5 />
                <IoLogoJavascript />
                <SiNodedotjs />
                <SiExpress />
                <SiMongodb />
              </div>
              <div>
                <a
                  className="project-deployed-link"
                  href="https://mailchimp-clone-deploy.netlify.app/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline onbt">
                    See this Live
                  </span>
                </a>
                <a
                  className="project-github-link"
                  href="https://github.com/vivekbtu/MailChimp-Clone"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline">
                    View Code
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* GET HARVEST */}

        <div className="project-card">
          <div className="project">
            <div className="project_videocontainer">
              <div data-aos="fade-right">
                <img
                  src="https://user-images.githubusercontent.com/101381281/204876207-391fa84c-2a1f-4a43-8402-bb35e38a94d9.png"
                  alt="Getharvest"
                />
              </div>
            </div>
            <div className="project_information" data-aos="fade-right">
              <h2 className="project-title">Getharvest Clone</h2>
              <p className="project-description">
              Harvest or Getharvest is a web-based time tracking, Project Management, Invoicing, and cost-tracking tool. which is used by more than 70000+ companies.
              </p>
              <div className="project-tech-stack">
                <FaReact />
                <SiHtml5 />
                <IoLogoJavascript />
                <SiNodedotjs />
              </div>
              <div>
                <a
                  className="project-deployed-link"
                  href="https://glowing-jelly-1ca7fb.netlify.app/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline onbt">
                    See this Live
                  </span>
                </a>
                <a
                  className="project-github-link"
                  href="https://github.com/vivekbtu/premium-grade-140"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline">
                    View Code
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* <div className="projects_container">
          <div className="project">
            <div className="project_videocontainer">
              <div data-aos="fade-right">
                <img
                  src="https://news-cdn.softpedia.com/images/news2/Dropbox-2-9-Enters-Development-with-Streaming-Sync-Feature-442773-2.jpg"
                  alt=""
                />
              </div>
            </div>
            <div className="project_information" data-aos="fade-right">
              <h2>Backend API for Drive / DropBox Clone </h2>
              <p>
                Backend API for a google drive like app built using NodeJS, Express, Mongoose, MongoDB Atlas and AWS S3 for storage. A solo project. CRUD operations for users, files and folders.
              </p>
              <div>
                <SiNodedotjs />
                <SiExpress />
                <SiMongodb />
              </div>
              <div>
                <a
                  href="https://isnt-bittubieber19-gmail-com-awesome-20dbc.netlify.app/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline onbt">
                    URL for the API
                  </span>
                </a>
                <a
                  href="https://github.com/vivekbtu/bitter-level-627"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline">
                    View Code
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div> */}

        

         {/* TIC-TAC-TOE */}


        <div className="project-card">
          <div className="project">
            <div className="project_videocontainer">
              <div data-aos="fade-right">
                <img
                  src="https://user-images.githubusercontent.com/101381281/204876613-d0d2abe9-cae6-4a7f-be71-e4c0e3ea6b8f.png"
                  alt="TicTacToe"
                />
              </div>
            </div>
            <div className="project_information" data-aos="fade-right">
              <h2 className="project-title">Classic TicTacToe</h2>
              <p className="project-description">
                Mini project of A classic TicTacToe game built using ReactJS. Features : Button for Resetting The Game, etc.
              </p>
              <div class="project-tech-stack">
                <FaReact />
                <SiHtml5 />
                <DiCss3 />
              </div>
              <div>
                <a
                  className="project-deployed-link"
                  href="https://csb-lniujk.netlify.app/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline onbt">
                    See this Live
                  </span>
                </a>
                <a
                  className="project-github-link"
                  href="https://github.com/vivekbtu/Tic-Tac-Toe"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline">
                    View Code
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* ASOS.COM */}


        <div className="project-card">
          <div className="project">
            <div className="project_videocontainer">
              <div data-aos="fade-right">
                <img
                  src="https://user-images.githubusercontent.com/88669777/192659802-d5994309-ad51-40a8-98de-5d292b7d844a.png"
                  alt="TicTacToe"
                />
              </div>
            </div>
            <div className="project_information" data-aos="fade-right">
              <h2 className="project-title">Asos.com Clone</h2>
              <p className="project-description">
                This is a clone of asos.com, which is an E-commerce website. we have a home page, product page, and sorting, filtering, and searching functionality with a Login Authentication System. I also added a cart,coupons, entering and saving details of cards and addresses of customers, and dispatching a product.This project was collaborated by team of five and completed in just five days.
              </p>
              <div className="project-tech-stack">
                <SiHtml5 />
                <DiCss3 />
                <IoLogoJavascript />
              </div>
              <div>
                <a
                  className="project-deployed-link"
                  href="https://steady-swan-edc8d5.netlify.app/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline onbt">
                    See this Live
                  </span>
                </a>
                <a
                  className="project-github-link"
                  href="https://github.com/arsalanshaikhh/asos.com-clone-Unit2"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline">
                    View Code
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
